module.exports = __webpack_public_path__ + "assets/img/2141591934007_.pic_hd.9549c876.jpg";